// @flow

import { ArrowRight, Check } from 'lucide-react';

import { Base } from '@gandi/ui';

import styles from './CommercialPoint.scss';

export type Props = {
  children: string | React.MixedElement,
  iconName: 'arrowRight' | 'checkmark',
};

export function CommercialPoint({
  children,
  iconName,
}: Props): React.MixedElement {
  const Icon = iconName === 'arrowRight' ? ArrowRight : Check;
  return (
    <Base
      tagName="li"
      className={styles.listItem}
      flex
      flexAlignItemsCenter
      flexBasis0
    >
      <Icon size={16} />
      <p>{children}</p>
    </Base>
  );
}
